import { QueryData } from "@supabase/supabase-js";
import { queryOptions } from "@tanstack/react-query";
import { IterableElement } from "type-fest";

import { supabase } from "@/lib/supabase";

export type Estimate = IterableElement<QueryData<typeof estimateListQuery>>;

const estimateListQuery = supabase
  .from("Estimate")
  .select("*, customer:Customer(id,name,billing), customFieldValues:EstimateCustomFieldValue(*)")
  .eq("deleted", false)
  .order("date", { ascending: false })
  .throwOnError();

export const estimateListQueryOptions = queryOptions({
  queryKey: ["Estimate", "list"],
  queryFn: async () => (await estimateListQuery).data,
});
